import React, { useContext, useRef } from "react";
import $ from "jquery";

import { Accordion } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";

import Skeleton from "../utils/Skeleton";
import { MainContext } from "./../../context/main-context";
import { MapBtn, CalcBtn, ChartBtn, DisableBtn } from "../utils/Btns";
import { DataContext } from "../../context/data-context";

const Compo = ({
  staticValue,
  dynamicValue,
  AccordionHeaderHandler,
  index,
  id,
  onClick,
}) => {
  const acItem = staticValue;
  const data = dynamicValue.filter((item) => item.id != 305);
  // const busLinesData =
  //   id == 300 && !$.isEmptyObject(data)
  //     ? dynamicValue.find((item) => item.id == 305)
  //     : []; // busLines is 305
  const data201 =
    id == 200 && !$.isEmptyObject(data)
      ? data.find((item) => item.id == 201)
      : []; // teraffic is 201
  const data203 =
    id == 200 && !$.isEmptyObject(data)
      ? data.find((item) => item.id == 203)
      : []; // tarh is 203
  const mainContext = useContext(MainContext);
  const dataContext = useContext(DataContext);

  const acItemRef = useRef();
  const handleMainPanelShow = async (state) => {
    await mainContext.toggleShowLeftPanel(!state);
    await mainContext.toggleShowMainPanel(state);
    await mainContext.toggleShowRightPanelMd(false);
  };

  const handleMainPanelSetContent = (id) => {
    const content = data.find((item) => item.id === id);
    mainContext.showMainContent(content);
    if (id == 303) {
      mainContext.toggleBusLineDataShow(true);

    } else {
      mainContext.toggleBusLineDataShow(false);
    }
  };

  return (
    <Accordion.Item eventKey={index} ref={acItemRef} itemID={id}>
      <Accordion.Header onClick={AccordionHeaderHandler} onFocus={onClick}>
        {acItem.icon}
        <h4 className="f-Black f-14px mb-0"> {acItem.title}</h4>
      </Accordion.Header>

      <Accordion.Body className="p-0 m-0">
        <div className="rp-collapse-item-content-subTitle">
          {acItem.subItems.map((val, key) => (
            <div key={key} className="px-3 py-2">
              <div className="subTitle-header pt-2">
                <div className="subTitle-header-title">
                  <FaCircle color="#c82021" fontSize=".5rem" />
                  <h5 className="f-Regular f-14px red">{val.title}</h5>
                </div>
                {/* <div className="subTitle-header-value">{5}</div> */}
                <div className="subTitle-header-value">
                  {$.isEmptyObject(data) ? (
                    <Skeleton />
                  ) : val.id == 201 ? ( //inja bayad validation beshe age beyn baze felan ta felane shologhe khalvate chie Alan malom nist va man data testi mizaram!
                    `نسبتا شلوغ`
                  ) : val.id == 203 ? (
                    `${
                      data203.value[0].state + data203.value[1].state == 0
                        ? "ندارد"
                        : `${
                            data203.value[0].state + data203.value[1].state
                          }مورد`
                    }`
                  ) : (
                    `${
                      data.find((item) => item.id == val.id).value.length
                    } مورد`
                    // <strong className="bind"></strong>(val.id)
                  )}
                </div>
              </div>
              <div className="subTitle-content mt-2">
                {$.isEmptyObject(data) ? (
                  <Skeleton type="bg" />
                ) : val.id == 201 ? null : val.id == 203 ? (
                  <div className="subTitle-content-row  ">
                    <p className="f-12px f-Regular gray mb-0 px-3">
                      {!data203.value[0].state && !data203.value[1].state
                        ? null
                        : val.title}
                    </p>
                    <div className="d-flex gap-1">
                      {data203.value[0].state && data203.value[0].name ? (
                        <p className="f-12px f-Bold red my-1  bgWhite">
                          {data203.value[0].state && data203.value[0].name}
                        </p>
                      ) : null}
                      {data203.value[1].state && data203.value[1].name ? (
                        <p className="f-12px f-Bold red my-1  bgWhite">
                          {data203.value[1].state && data203.value[1].name}
                        </p>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  data
                    .find((item) => item.id == val.id)
                    .value.map((value, index) => (
                      <div key={index} className="subTitle-content-row  ">
                        <p className="f-12px f-Regular gray mb-0 px-3">
                          {val.title}
                        </p>
                        <p className="f-12px f-Bold red my-1  bgWhite">
                          {$.isEmptyObject(data) ? <Skeleton /> : value.name}
                        </p>
                      </div>
                    ))
                )}
              </div>
              {/* btn har section */}
              {$.isEmptyObject(data) ? (
                <DisableBtn style={{ margin: ".8rem 0 .8rem 0" }} />
              ) : (
                <div className="subTitle-content-btns my-3">
                  {val.btns.map ? (
                    <div className="subTitle-content-btn">
                      <MapBtn
                        onClick={() => {
                          handleMainPanelShow(true);
                          handleMainPanelSetContent(val.id);
                        }}
                      />
                    </div>
                  ) : null}
                  {val.btns.calc ? (
                    <div className="subTitle-content-btn">
                      <CalcBtn
                        onClick={() => {
                          handleMainPanelShow(true);
                          handleMainPanelSetContent(val.id);
                        }}
                      />
                    </div>
                  ) : null}
                  {val.btns.chart ? (
                    <div className="subTitle-content-btn">
                      <ChartBtn
                        onClick={() => {
                          handleMainPanelShow(true);
                          handleMainPanelSetContent(val.id);
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              )}

              {key !== acItem.subItems.length - 1 ? (
                <div className="subTitle-divideLine"></div>
              ) : null}
            </div>
          ))}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};
let AccordionItem;
export default AccordionItem = React.memo(Compo);
